import React, { Component } from 'react';
import { DISPATCH_ID, } from '../libs/utils/Const';
import { connect } from 'react-redux';
import '../css/dataTables.css';
import $ from 'jquery';
import AreYouAgreeModal from './AreYouAgreeModal';

class NewCustomerModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchInTable: ''
        }

    }

    componentDidMount() {
        this.closeAction();
    }

    closePartner = async () => {
        $('#newCustomer').modal('hide');
    };

    closeAction = () => {
        const { cleanData } = this.props;
        $('#newCustomer').on('hide.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const {
            PointsCardModel,
            change_CardName,
            change_U_FMB_Handel_Email,
            change_U_FMB_Cellular,
            change_U_FMB_Handel_Pass,
            sendNewCustomer,
            activeShowAreYouAgree_Update,
            showAreYouAgreeModal_Update,
            UpdateCustomer,
            desactiveShowAreYouAgree_Update,
            action,
        } = this.props;

        return (
            <div className="modal fade bd-example-modal-md modal-open scroll"
                id="newCustomer"
                role="dialog"
                aria-labelledby="newCustomerModal"
                aria-hidden="true">

                <div className="modal-dialog modal-md modal-open" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Registros de monedero electrónico
                            </h4>
                            <button type="button" className="close" onClick={this.closePartner} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Código de Socio</span>
                                                </div>
                                                <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                                                    disabled="true"
                                                    value={PointsCardModel.Customer.CardCode ? PointsCardModel.Customer.CardCode : ''} />
                                            </div>
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre de Usuario</span>
                                                </div>
                                                <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                                                    // style={{ backgroundColor: PointsCardModel.Customer.partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                                                    disabled={(action === 1 || action === 2) ? true : false}
                                                    // onKeyPress={(ev) => {
                                                    //     if (ev.key === 'Enter') {
                                                    //         this.openPartner();
                                                    //     }
                                                    // }}
                                                    onChange={change_CardName}
                                                    value={PointsCardModel.Customer.CardName ? PointsCardModel.Customer.CardName : ''} />
                                            </div>

                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Correo Electrónico</span>
                                                </div>
                                                <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                                                    // style={{ backgroundColor: PointsCardModel.Customer.partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                                                    // disabled={action === 2 && !editMode ? true : false}
                                                    // onKeyPress={(ev) => {
                                                    //     if (ev.key === 'Enter') {
                                                    //         this.openPartner();
                                                    //     }
                                                    // }}
                                                    onChange={change_U_FMB_Handel_Email}
                                                    value={PointsCardModel.Customer.U_FMB_Handel_Email ? PointsCardModel.Customer.U_FMB_Handel_Email : ''} />
                                            </div>

                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Teléfono</span>
                                                </div>
                                                <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                                                    // style={{ backgroundColor: PointsCardModel.partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                                                    // disabled={action === 2 && !editMode ? true : false}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.openPartner();
                                                        }
                                                    }}
                                                    maxLength={12}
                                                    onChange={change_U_FMB_Cellular}
                                                    value={PointsCardModel.Customer.U_FMB_Cellular ? PointsCardModel.Customer.U_FMB_Cellular : ''} />
                                            </div>

                                            {action === 2 && <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Contraseña</span>
                                                </div>
                                                <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                                                    // style={{ backgroundColor: PointsCardModel.Customer.partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                                                    // disabled={action === 2 && !editMode ? true : false}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.openPartner();
                                                        }
                                                    }}
                                                    maxLength={20}
                                                    onChange={change_U_FMB_Handel_Pass}
                                                    value={PointsCardModel.Customer.U_FMB_Handel_Pass ? PointsCardModel.Customer.U_FMB_Handel_Pass : ''} />
                                            </div>}

                                            {/* <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Confirmar Contraseña</span>
                                                </div>
                                                <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                                                    // style={{ backgroundColor: PointsCardModel.Customer.partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                                                    // disabled={action === 2 && !editMode ? true : false}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.openPartner();
                                                        }
                                                    }}
                                                    onChange={change_E_Mail}
                                                    value={PointsCardModel.Customer.U_FMB_Handel_Pass ? PointsCardModel.Customer.U_FMB_Handel_Pass : ''} />
                                            </div> */}

                                            {/* <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Género</span>
                                                </div> */}
                                            {/* <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                                                    // style={{ backgroundColor: PointsCardModel.Customer.partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                                                    // disabled={action === 2 && !editMode ? true : false}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.openPartner();
                                                        }
                                                    }}
                                                    onChange={change_E_Mail}
                                                    value={PointsCardModel.Customer.E_Mail ? PointsCardModel.Customer.E_Mail : ''} /> */}

                                            {/* <select className="form-control" id="genero" name="genero">
                                                    <option value="masculino">Masculino</option>
                                                    <option value="femenino">Femenino</option>
                                                    <option value="otro">Otro</option>
                                                </select>
                                            </div> */}

                                            {/* <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Dirección</span>
                                                </div>
                                                <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                                                    // style={{ backgroundColor: PointsCardModel.Customer.partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                                                    // disabled={action === 2 && !editMode ? true : false}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.openPartner();
                                                        }
                                                    }}
                                                    onChange={change_E_Mail}
                                                    value={PointsCardModel.Customer.E_Mail ? PointsCardModel.Customer.E_Mail : ''} />
                                            </div> */}

                                            {/* <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Ciudad</span>
                                                </div>
                                                <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                                                    // style={{ backgroundColor: PointsCardModel.Customer.partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                                                    // disabled={action === 2 && !editMode ? true : false}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.openPartner();
                                                        }
                                                    }}
                                                    onChange={change_E_Mail}
                                                    value={PointsCardModel.Customer.E_Mail ? PointsCardModel.Customer.E_Mail : ''} />
                                            </div> */}

                                            {/* <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Código Postal</span>
                                                </div>
                                                <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                                                    // style={{ backgroundColor: PointsCardModel.Customer.partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                                                    // disabled={action === 2 && !editMode ? true : false}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.openPartner();
                                                        }
                                                    }}
                                                    onChange={change_E_Mail}
                                                    value={PointsCardModel.Customer.E_Mail ? PointsCardModel.Customer.E_Mail : ''} />
                                            </div> */}

                                            {/* <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Género</span>
                                                </div> */}
                                            {/* <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                                                    // style={{ backgroundColor: PointsCardModel.Customer.partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                                                    // disabled={action === 2 && !editMode ? true : false}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.openPartner();
                                                        }
                                                    }}
                                                    onChange={change_E_Mail}
                                                    value={PointsCardModel.Customer.E_Mail ? PointsCardModel.Customer.E_Mail : ''} /> */}

                                            {/* <select className="form-control" id="genero" name="genero">
                                                    <option value="pais1">País 1</option>
                                                    <option value="pais2">País 2</option>
                                                </select>
                                            </div> */}

                                            {/* <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text">
                                                        <input type="checkbox" aria-label="Checkbox for following text input" />
                                                    </div>
                                                </div>
                                                <input type="text" className="form-control" aria-label="Text input with checkbox" style={{ fontWeight: 'bold' }} value="Acepto los Términos y Condiciones" disabled />
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closePartner} >Cerrar</button>
                            {action === 1 && <button type="button" className="btn botonCorrect text-black" onClick={sendNewCustomer} >Registrar</button>}
                            {action === 2 && <button type="button" className="btn botonCorrect text-black" onClick={activeShowAreYouAgree_Update} >Actualizar</button>}
                        </div>
                    </div>
                </div>

                {showAreYouAgreeModal_Update &&
                    <AreYouAgreeModal
                        mensaje={'¿Estás seguro que deseas actualizar la información del socio?'}
                        accept={UpdateCustomer}
                        cancel={desactiveShowAreYouAgree_Update}
                    />
                }
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewCustomerModal);